<template>
  <page-layout class="reporting_article" v-if="loaded">

    <sub-page-layout no-border no-right-padding-top :event-info="getCurrentEventInfo">

      <div class="con_wrapper">

        <!-- Live Updates Contents -->
        <div class="tab_con">

          <div class="report">
            <!-- 제목 영역 -->
            <div class="data">
              <p class="subj">{{post.title}}</p>
              <p class="date_area">
                <i class="date">Posted {{post.pub_dt}} {{post.pub_tm}}</i>
                <i class="level">{{post.level_info}}</i>
                <router-link :to="`/article/editor/${post.writer.idx}`" class="editor">
                  <em class="img"><img v-if="isFileExist(post.writer.prof_img)" :src="post.writer.prof_img.url"></em>
                  <em class="name">{{post.writer.nick}}</em>
                </router-link>
              </p>
            </div>
            <!-- 본문 영역 -->
            <div class="detail_con">
              <div class="con_view">
                <div v-html="post.contents"></div>
                <div class="channel">
                  <p>Follow <b>Bluff&amp;Catch</b>'s official social media accounts for more information!</p>
                  <a class="ctnr" href="https://www.facebook.com/BluffCatch" target="_blank">
                    <p class="img"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/36618/tips_ico_fb.png"></p>
                    <h6>Facebook</h6>
                    <p class="btn">Follow</p>
                  </a>
                  <a class="ctnr" href="https://t.me/bluffcatch_en" target="_blank">
                    <p class="img"><img src="https://d1c5n4ri2guedi.cloudfront.net/corp/2/tips/36619/tips_ico_tg.png"></p>
                    <h6 class="tg">Telegram</h6>
                    <p class="btn tg">Join</p>
                  </a>
                </div>
              </div>

              <!-- copyright -->
              <div class="copy">Copyright ⓒ Bluff&amp;Catch. All rights reserved.<p>This material may not be reproduced, displayed, modified or distributed without the express prior written permission of the copyright holder.</p></div>

              <!-- 태그 -->
              <div class="tag">
                <p class="h_tags">
                  <i class="tit">TAGs</i>
                  <router-link :to="`/article/tag/${tag}`" v-for="tag in post.tags" :key="tag">{{tag}}</router-link>
                </p>
              </div>

              <!-- 에디터 -->
              <div class="editor" v-if="post.writer">
                <p class="img"><img v-if="isFileExist(post.writer.prof_img)" :src="getFileExist(post.writer.prof_img)"></p>
                <p class="name">{{post.writer.nick}}</p>
                <p class="position">{{post.writer.position}}</p>
                <router-link :to="`/article/editor/${post.writer.idx}`">Read More</router-link>
              </div>

            </div>

          </div>

        </div>

      </div>

    </sub-page-layout>
  </page-layout>
</template>

<script>
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import ReportInfo from '../components/ReportInfo'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
	import {Dialog, Popover} from 'element-ui'
  import {QDialog, QBtn, QBtnGroup, QDate, QCard, QSeparator} from 'quasar'
  const baseAction = '/live/posts'
  export default {
    name: 'ReportingArticle',
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      ReportInfo,
			QDialog, QBtn, QBtnGroup, QCard, QDate, QSeparator,
      [Dialog.name]: Dialog,
      [Popover.name]: Popover
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | ${this.getPostTitle}`,
        titleTemplate: '%s',
        meta: this.getSeoMeta
      }
    },
    data () {
      return {
        baseAction: baseAction,
        loaded: false,
        idx: '',
        post: {},
      }
    },
		activated () {
      this.getPostData()
    },
    beforeRouteUpdate (to, from, next) {
      if (from.params.idx !== to.params.idx) {
        next()
        this.getPostData()
      } else {
        next(false)
      }
    },
		mounted () {
    },
    computed: {
      ...CommonComputed,
      getPostIdx () {
        return this.$route.params.idx
      },
      getAccess () {
        return 'pc'
      },
      isPC () {
        return this.getAccess === 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
		 	isOpenShareDialog: {
        get () {
          return this.$store.getters.isOpenShareDialog
        },
        set (flag) {
          this.$store.dispatch('setOpenShareDialog', flag)
        }
      },
      getPostTitle () {
        return this.post && this.post.title ? this.post.title : ''
      },
      getSeoMeta () {
        return this.post ? this.post.seo_meta : []
      },
      getCurrentEventInfo () {
        return this.post.live_reporting.days.data[this.post.live_reporting_day].info
      }
    },
    methods: {
      ...CommonMethods,
      getPostData () {
        this.idx = this.getPostIdx
        if (!this.idx) return

        // view_cnt 업데이트
        this.$axios.put(baseAction + '/view_cnt/' + this.idx)

        // content 가져오기
        this.$axios.get(baseAction + '/' + this.idx).then(rs => {
          this.post = rs.data

          this.$store.dispatch('setCurrentContentsData', rs.data)
          this.loaded = true
        }).catch(() => {
          this.$router.push('/')
        })
      },
			toggleShareDialog (flag) {
        this.$store.dispatch('setOpenShareDialog', flag)
      },
    },
  }
</script>

<style scoped>
  .con_wrapper {
    width: 700px;
    margin: 0 auto;
    padding-bottom: 100px;
  }
  .report {
    padding: 0;
  }
  .report .data {
    position: relative;
    padding-bottom: 15px;
    margin-bottom: 50px;
    border-bottom: 1px solid #e5e5e5;
  }
  .report .subj {
    font-size: 32px;
    color: #000;
    font-weight: 700;
    line-height: 1.4em;
    letter-spacing: -0.02em;
  }
  .report .date_area {
    font-size: 14px;
    margin-top: 35px;
    font-weight: 500;
  }
  .report .date_area i {
    padding-right: 10px;
    color: #777;
  }
  .report .date_area i:first-child:after {
    content: "/";
    color: #ccc;
    padding-left: 10px;
  }
  .report .date_area .editor {
    font-size: 14px;
    margin-left: 35px;
  }
  .report .date_area .editor .img {
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 100%;
    overflow: hidden;
    padding-left: 0;
    transform: translate(0, -6px);
  }
  .report .date_area .editor .img img {
    width: 100%;
    height: 100%;
  }
  .report .date_area .editor .name {
    font-weight: 600;
    color: #000;
    transition: .15s;
  }
  .report .date_area .editor:hover .name {
    color: #379339;
    text-decoration: underline;
  }
  .report .date_area .editor em {
    font-style: normal;
    padding-left: 15px;
  }

  .detail_con {
    padding: 0;
  }
  .detail_con .con_view {
    font-size: 16px;
    line-height: 1.9em;
    color: #333;
    word-break: normal;
    padding-bottom: 100px;
  }
  /deep/ .detail_con .con_view strong,
  /deep/ .detail_con .con_view b {
    font-weight: 600;
  }
  .report .tag {
    position: relative;
    padding-left: 60px;
  }
  .report .tag .h_tags  {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.0em;
  }
  .report .tag .h_tags .tit {
    color: #000;
    font-weight: 600;
    position: absolute;
    left: 0;
  }
  .report .tag .h_tags a {
    display: inline-block;
    margin: 0 12px 12px;
    font-size: 15px;
    color: #379339;
    border-bottom: 1px solid #379339;
  }
  .report .tag .h_tags a:hover {
    color: #000;
    border-color: #000;
  }
  .detail_con .channel {
    padding: 15px 18px;
    background: #fff;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 10px;
    margin: 35px 0;
    text-align: center;
  }
  .detail_con .channel .img {
    display: inline-block;
  }
  .detail_con .channel .img img {
    width: 38px;
    background: none;
  }
  .detail_con .channel p {
    margin: 6px 0;
    color: #000;
  }
  .detail_con .channel p span {
    font-weight: 700;
    color: #1e94d3;
  }
  .detail_con .channel .ctnr {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: auto;
    text-decoration: none;
    margin: 0 25px;
  }
  .detail_con .channel .ctnr h6 {
    font-size: 16px;
    font-weight: 600;
    color: #1877f2;
    margin: 0 10px;
    letter-spacing: -0.01em;
  }
  .detail_con .channel .ctnr h6.tg {
    color: #2ea5d9;
  }
  .detail_con .channel .ctnr .btn {
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    color: #444;
    line-height: 1.0em;
    background: #efefef;
/*    background: #1877f2;*/
    padding: 10px 16px 10px 20px;
    margin-left: 5px;
    border-radius: 5.0em;
    z-index: 1;
  }
  .detail_con .channel .ctnr .btn.tg {
/*    background: #2ea5d9;*/
  }
  .detail_con .channel .ctnr .btn:after {
    content: "⟶";
    font-size: 8px;
    padding-left: 7px;
  }
  .detail_con .copy {
    font-size: 0.9em;
    font-weight: 500;
    margin-bottom: 50px;
    line-height: 1.5em;
  }
  .detail_con .editor {
    padding: 20px;
    background: #ebebeb;
    font-size: 14px;
    margin: 35px 0;
    display: flex;
    align-items: center;
    position: relative;
  }
  .detail_con .editor .img {
    display: inline-block;
  }
  .detail_con .editor .img img {
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .detail_con .editor p {
    display: inline-block;
    margin: 0 10px;
  }
  .detail_con .editor p.name {
    font-weight: 700;
  }
  .detail_con .editor p.position {
    border-left-color: #888;
  }
  .detail_con .editor a {
    position: absolute;
    right: 30px;
    font-weight: 500;
    color: #000;
    text-decoration: underline;
  }
  .detail_con .editor a:hover {
    color: #379339;
  }
  .detail_con /deep/.ad_article {
    padding: 60px 20px 20px;
    background: #fff;
    display: inline-block;
    margin: 40px 0;
    position: relative;
  }
  .detail_con /deep/.ad_article img {
    width: 100%;
  }
  .detail_con /deep/.ad_article:before {
    content: "Advertisement";
    position: absolute;
    top: 15px;
    left: 20px;
    font-size: 0.9em;
    color: #333;
    line-height: 1.0em;
    padding: 7px 10px;
    border-radius: 5.0em;
    background: #f1f1f1;
  }
  .list_btn {
    display: block;
    text-align: center;
    width: 40%;
    padding: 15px 0;
    margin: 50px auto 0;
    font-size: 20px;
    color: #222;
    font-weight: 700;
    letter-spacing: -0.5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    transition: all 0.15s;
  }
  .list_btn:hover {
    color: #379339;
    border-color: #379339;
  }


  /* 콘텐츠 내 강제 지정 스타일 */
  /deep/ .con_view .card {
    font-size: 14px;
    font-weight: 900;
    padding: 0 3px;
    border: 1px solid #ccc;
    border-radius: 3px;
    background: #fff;
    margin: 2px;
  }
  /deep/ .con_view .card.black {
    color: #000;
  }
  /deep/ .con_view .card.red {
    color: #de0000;
  }
  /deep/ .con_view span a, /deep/ .con_view div a, /deep/ .con_view table a {
    color: #379339 !important;
    font-weight: 700;
    text-decoration: underline;
  }
  /deep/ .con_view span a img, .con_view div a img {
    background: #fff;
  }
  /deep/ .con_view span a:hover, /deep/ .con_view div a:hover, /deep/ .con_view table a:hover {
    color: #000 !important;
  }
  /deep/ .con_view span a u, .con_view div a u, .con_view a u {
    text-decoration: none !important;
  }
  /deep/ .con_view table {
    margin: 5px 0;
    width: 100%;
  }
  /deep/ .con_view table td {
    width: fit-content !important;
    padding: 8px 20px;
    background: #fff;
    font-size: 0.9em;
    font-weight: 500;
    line-height: 1.4em;
		vertical-align: middle;
    border-bottom: 1px solid #eee;
  }
  /deep/ .con_view table tr:first-child td {
    color: #379339;
    border-top: 1px solid rgba(55,147,57,0.35);
  }
  /deep/ .con_view table tr:nth-child(even) td {
    background: #fbfbfb;
  }
  /deep/ .con_view p.box {
    display: block;
    font-size: 0.9em;
    padding: 20px 30px;
    line-height: 1.8em;
    background: #eee;
    border: none;
  }
  /deep/ .con_view a.btn_article {
    display: inline-block;
    width: 75%;
    padding: 14px;
    border-radius: 10px;
    background: #008c03;
    font-size: 1.3em;
    font-weight: 400;
    color: #fff !important;
    text-align: center;
    text-decoration: none;
    line-height: 1.4em;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
  }
  /deep/ .con_view a.btn_article:hover {
    color: #fff !important;
    background: #006702;
  }
  /deep/ .con_view a.btn_article:after {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    border: solid #fff;
    border-width: 2px 2px 0 0;
    position: absolute;
    right: 8%;
    top: 50%;
    transform: rotate(45deg) translate(0, -75%);
  }
	/deep/ .con_view img {
    width: 100%;
	}
	/deep/ img[name^="target_resize_image[]"] {
		margin: 0 auto;
		display: block;
		max-width: 760px;
	}
	/deep/ .m-show {
		display: none;
	}
  /deep/ .fr-video { display: block !important; position: relative !important; height: 0 !important; padding-bottom: 56.25% !important; }
  /deep/ .fr-video iframe { position: absolute !important; width: 100% !important; height: 100% !important; top:0; left: 0; }
  /deep/ [data-f-id="pbf"] {
    display: none;
  }
  .p-hide {
    display: none;
  }
  /deep/ .report_info {
    margin-top: 0;
  }
</style>
